export default __webpack_public_path__ + "static/media/049-lighthouse.92466db3.svg";